// import { Checkbox } from '@material-ui/core';
// import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';

const useAttendanceMember = () => {
    const columns = [
        {
            field: 'name',
            headerName: 'Name',
            width: 120,
            renderCell: (params) => {
                return (
                    <div>{`${params.row.firstName ? params.row.firstName : ''} ${
                        params.row.surname ? params.row.surname : ''
                    }`}</div>
                );
            },
        },
        { field: 'gender', headerName: 'Gender', width: 80 },
        { field: 'institution', headerName: 'Institution', width: 120 },
        { field: 'department', headerName: 'Department', width: 140 },
        { field: 'post', headerName: 'Post', width: 100 },
        {
            field: 'chairman',
            headerName: 'Chairman',
            width: 100,
            // renderCell: (params) => {
            //     return <Checkbox color="primary" />;
            // },
        },
        {
            field: 'role',
            headerName: 'Role',
            width: 220,
            // renderCell: (params) => {
            //     return (
            //         <CustomOutlineSelect
            //             value={'0'}
            //             onChange={(e) => {}}
            //             choices={[
            //                 { key: '0', display: 'Scientific Member' },
            //                 { key: '1', display: 'Non-scientific Member' },
            //             ]}
            //             // placeholder={'Please choose your decision'}
            //         />
            //     );
            // },
        },
        {
            field: 'independent',
            headerName: 'Independent',
            width: 80,
            // renderCell: (params) => {
            //     return <Checkbox color="primary" />;
            // },
        },

        {
            field: 'attend',
            headerName: 'Attend Meeting?',
            width: 80,
            // renderCell: (params) => {
            //     return <Checkbox color="primary" />;
            // },
        },
        { field: 'email', headerName: 'Email', width: 200 },
    ];

    const rows = [
        {
            surname: 'Peter',
            firstName: 'Chan',
            gender: 'M',
            institution: 'HKU',
            department: 'DEF Dept',
            post: 'Doctor',
            chairman: 'Yes',
            role: 'Scientific Member',
            independent: true,
            attend: true,
            email: 'peter@ha.org.hk',
        },
    ];

    return { rows: rows, columns: columns };
};

export default useAttendanceMember;
